export enum SmartAppBannerPlatformEnum {
  Android = 'android',
  IOS = 'ios'
}
